<template lang="html">
  <v-container class='fluid'>
    <v-layout align-center justify-center>
      <v-flex xs10>
        <v-card class="text-xs-center">

          <!-- Título da página -->
          <basic-toolbar :title="'Cadastrar Instituição'"></basic-toolbar>

          <v-card-text>
            <v-form v-model="formularioValido" ref="form">
              <v-container>

                <!-- Nome -->
                <v-layout row>
                  <v-flex xs12>
                    <v-text-field
                      label='Nome*'
                      v-model="instituicao.nome"
                      counter="200"
                      :rules="[...obrigatorio,...max200caracteres]"
                    >
                    </v-text-field>
                  </v-flex>
                </v-layout>

                <!-- Sigla -->
                <v-layout row>
                  <v-flex xs12>
                    <v-text-field
                      label='Sigla'
                      v-model="instituicao.sigla"
                      counter="20"
                      :rules="max20caracteres"
                    >
                    </v-text-field>
                  </v-flex>
                </v-layout>

                <!-- País -->
                <v-layout row>
                  <v-flex xs12>
                    <v-select
                      label='País*'
                      :items="listaPaises"
                      v-model="instituicao.pais"
                      item-text="nome"
                      item-value="id"
                      max-height="400"
                      return-object
                      required
                      autocomplete
                      :rules="obrigatorio" >
                    </v-select>
                  </v-flex>
                </v-layout>

                <!-- Estado -->
                <v-layout row v-if="instituicao.pais !== null && instituicao.pais.nome === 'Brasil'">
                  <v-flex xs12>
                    <v-select
                      label='Estado*'
                      :items="listaEstados"
                      v-model="instituicao.estado"
                      item-text="nome"
                      item-value="id"
                      max-height="400"
                      return-object
                      required
                      autocomplete
                      :rules="obrigatorio" >
                    </v-select>
                  </v-flex>
                </v-layout>

                <br>

              </v-container>
            </v-form>

            <v-divider></v-divider>

            <v-card-actions>

              <!-- Botão "Cancelar" -->
              <v-btn color="primary" @click="cancelar()">Cancelar</v-btn>

              <v-spacer></v-spacer>

              <!-- Botão "Cadastrar" -->
              <v-btn color="primary" :disabled="!formularioValido" @click="cadastraInstituicao()">Cadastrar</v-btn>

            </v-card-actions>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import BasicToolbar from '@/components/toolbars/basic-toolbar'
  import projetos from '@/utils/projetos'
  import { mapActions } from 'vuex'

  export default {
    props: ['idProjetoPesquisa'],
    data: () => ({
      formularioValido: false,
      instituicao: {
        pais: null,
        cadastroAprovado: 'S'
      },
      listaPaises: [],
      listaEstados: [],
      obrigatorio: [v => !!v || 'Este campo é obrigatório'],
      max20caracteres: [v => v.length <= 20 || 'Este campo pode ter no máximo 20 caracteres'],
      max200caracteres: [v => v.length <= 200 || 'Este campo pode ter no máximo 200 caracteres']
    }),
    methods: {
      ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']),

      // Cadastra a instituição.
      cadastraInstituicao: function () {
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Cadastrando instituição...' })
        // Se a instituição não for do Brasil, não salva o estado.
        if (this.instituicao.pais !== null && this.instituicao.pais.nome !== 'Brasil') {
          this.instituicao.estado = null
        }
        projetos.postInstituicao(this.instituicao)
        .then(response => {
          this.SHOW_SNACKBAR({snackbarType: 'success', snackbarText: response.body.mensagem})
          this.$router.push({name: 'ProjetoPesquisaPesquisarInstituicao', params: {idProjetoPesquisa: this.idProjetoPesquisa}})
        })
        .catch(error => {
          this.SHOW_SNACKBAR({snackbarType: 'error', snackbarText: error.body.mensagem})
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Cadastrando instituição...' })
        })
      },

      // Redireciona para a página anterior.
      cancelar: function () {
        this.$router.go(-1)
      }
    },
    mounted () {
      // Carrega lista de países.
      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando países...' })
      projetos.getPaisesInstituicaoProjetoPesquisa()
      .then(response => {
        this.listaPaises = response.data.slice()
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando países...' })
      })

      // Carrega lista de estados.
      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando estados...' })
      projetos.getEstadosInstituicaoProjetoPesquisa()
      .then(response => {
        this.listaEstados = response.data.slice()
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando estados...' })
      })
    },
    components: {
      'basic-toolbar': BasicToolbar
    }
  }
</script>

<style lang="css">
  .menu {
    display: block !important;
  }

  .no-resize div textarea{
    resize: none;
  }
  .input-group__icon-cb {
    cursor: pointer !important;
  }
</style>



// WEBPACK FOOTER //
// cadastrar-instituicao.vue?bc06e704